import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 34px;
  height: 124px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.varPrimary};

  @media screen and (max-width: 768px) {
    padding: 10px 14px;
    background: ${({ theme }) => theme.colors.gray};
    border: 1px solid transparent;
  }

  img {
    width: 350px;

    @media screen and (max-width: 768px) {
      width: 12.5rem;
    }
  }

  nav {
    display: flex;

    ul {
      display: flex;

      li {
        display: flex;
        margin: 0 10px;

        a {
          display: flex;
          padding: 12px 15px;
          text-transform: uppercase;
          text-decoration: none;
          color: ${({ theme }) => theme.colors.auxiliar};
        }
      }
    }

    @media screen and (max-width: 950px) {
      display: none;
    }
  }
`;

export const ContainerButton = styled.div`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;
export const ContainerBar = styled.div`
  display: none;

  @media screen and (max-width: 950px) {
    display: flex;

    .iconBars {
      font-size: 3rem;
      cursor: pointer;
    }
  }
`;
